import React, { useEffect, useRef, useState } from 'react';
import { useModelsModalState, setModelsModalState } from '../../../../../store/state';
import { pageSize, useCateListFetch } from '../fetchHander';
import { innerMoreType, modelTypeMap } from '../../../../../constants';
import { v4 } from 'uuid';
import { useTempState } from '@shakkerai/pro-store';

const useScrollHandler = (target, menuPath, modelType) => {
  const { loading, fetchList } = useCateListFetch(menuPath.level, target, modelType, menuPath);
  const catesModels = useModelsModalState('catesModels');
  const baseTypes = useModelsModalState('baseTypes');
  const globalMode = useTempState('globalMode');
  const [list, setList] = useState([]);
  const [loadmore, setLoadMore] = useState(false);
  const [hasMore, setHasMore] = useState(true); // 到底了
  const turnPageErrorFlag = useRef(null); // 接口异常兜底

  const getModelList = async (params, isAppend = false) => {
    if (turnPageErrorFlag.current) return;
    setLoadMore(true);
    const res = await fetchList(params, target);
    if (!res) {
      turnPageErrorFlag.current = true;
      setLoadMore(false);
      return;
    }
    const key = `${menuPath.level}-${target.code}`;
    setModelsModalState({
      catesModels: {
        ...catesModels,
        [key]: list.map((li) => {
          if (li.type === innerMoreType.children) {
            return isAppend
              ? { ...li, list: li.list.concat(res.list), page: params.page }
              : { ...li, list: res.list, page: 1 };
          }
          return li;
        }),
      },
    });
    setLoadMore(false);
  };

  const onModelScroll = () => {
    const tgList = list[list.length > 1 ? 1 : 0];
    if (tgList.list.length >= tgList.total) {
      setHasMore(false);
    }
    if (loading || loadmore || tgList.list.length >= tgList.total) return;
    const page = tgList.page + 1;
    getModelList(
      {
        modelType: modelTypeMap[modelType],
        page,
        pageSize,
        requestId: tgList.requestId ?? v4(), // 翻页需要复用requestId，不然会出现重复数据
        tagCode: target.code,
        baseTypes: globalMode === 'pro' ? baseTypes : ['19'],
      },
      true,
    );
  };

  useEffect(() => {
    if (!menuPath) return;
    const key = `${menuPath.level}-${target.code}`;
    const tg = catesModels[key];
    if (tg) {
      setList(tg);
      setHasMore(true);
    }
  }, [catesModels, menuPath]);
  return { loading, loadmore, onModelScroll, list, hasMore };
};

export default useScrollHandler;
